import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  computed: {
    userInfo() {
      return this.$store.getters['UserStore/getUserInfo'];
    }
  },
  methods: {
    toastSuccess(msg) {
      toast(msg, {
        position: "top-right",
        timeout: 2000,
      });
    },
    toastError(msg) {
      toast.error(msg, {
        position: "top-right",
        timeout: 2000,
      });
    },
    toastInfo(msg) {
      toast.info(msg, {
        position: "top-right",
        timeout: 2000,
      });
    },
    toastWarning(msg) {
      toast.warning(msg, {
        position: "top-right",
        timeout: 2000,
      });
    },
    setDefaultTime(){
      const now = new Date();
      const offset = now.getTimezoneOffset();
      const localISOTime = new Date(now.getTime() - offset * 60000)
        .toISOString()
        .slice(0, 16); 

      return localISOTime;
    },
    
    syncEventTimeFromTemp(eventTimeTemp) {
      if (!eventTimeTemp) return;
      const local = new Date(eventTimeTemp);
      local.setSeconds(0, 0);
      const zoned = new Date(local.getTime() - local.getTimezoneOffset() * 60000);
      const isoNoZ = zoned.toISOString().slice(0, -1);

      return {
        specificTime: isoNoZ,
        fromTime: isoNoZ,
        toTime: isoNoZ,
        timeZoneOffset: '+09:00',
      };
    },
    
    gtinToGtinUri(gtin) {
      const withoutCountry = gtin.slice(0, -1); // 끝 체크디지트 제외

      // 회사코드 길이(예: 7자리)
      const companyPrefixLength = 10;

      const companyPrefix = withoutCountry.slice(0, companyPrefixLength);
      const itemReference = withoutCountry.slice(companyPrefixLength).padStart(3, '0'); // 패딩 추가

      return `urn:epc:id:sgtin:${companyPrefix}.${itemReference}`;
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    
    formatDistance(meters) {
      if (meters < 1000) return `${meters.toFixed(0)} m`;
      return `${(meters / 1000).toFixed(2)} km`;
    },

    prettyNumber(n) {
      const s = String(n);
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    
    isAdmin() {
      const role = this.userInfo?.groupNm;
      return role === "ROLE_ADMIN" || role === "ROLE_SYSTEM";
    },
    isSystem() {
      const role = this.userInfo?.groupNm;
      return role === "ROLE_SYSTEM";
    },

    urnToGtin14(urn) {
      const parts = urn.split(':');
      if (parts.length < 6) return null;

      const sgtinParts = parts[5].split('.');
      if (sgtinParts.length < 2) return null;

      const companyPrefix = sgtinParts[0]; // 예: 8808123456
      const itemRef = sgtinParts[1];       // 예: 509

      // 1. Indicator digit (보통 0 사용)
      const indicator = '0';

      // 2. GTIN body 생성
      const itemRefPadded = itemRef.padStart(3, '0'); // 3자리 유지
      const gtinWithoutCheckDigit = indicator + companyPrefix + itemRefPadded;

      // 3. 체크디지트 계산 (Mod 10)
      const digits = gtinWithoutCheckDigit.split('').map(Number);
      let sum = 0;
      for (let i = digits.length - 1; i >= 0; i--) {
        const weight = (i % 2 === 0) ? 3 : 1;
        sum += digits[i] * weight;
      }
      const checkDigit = (10 - (sum % 10)) % 10;

      // 4. GTIN-14 완성
      return gtinWithoutCheckDigit + checkDigit;
    },

    shortUrnToGtin14(urn) {
      if (!urn) return '';
      const parts = urn.split(':');
      if (parts.length < 5) return null;

      const sgtinParts = parts[4].split('.');
      if (sgtinParts.length < 2) return null;

      const companyPrefix = sgtinParts[0]; // 예: 8808123456
      const itemRef = sgtinParts[1];       // 예: 509

      const indicator = '0';
      const itemRefPadded = itemRef.padStart(3, '0');
      const gtinWithoutCheckDigit = indicator + companyPrefix + itemRefPadded;

      const digits = gtinWithoutCheckDigit.split('').map(Number);
      let sum = 0;
      for (let i = digits.length - 1; i >= 0; i--) {
        sum += digits[i] * ((i % 2 === 0) ? 3 : 1);
      }
      const checkDigit = (10 - (sum % 10)) % 10;

      return gtinWithoutCheckDigit + checkDigit;
    },

    fmtKg(v){
      if(v == null || isNaN(v)) return '0.000'
      return Number(v).toFixed(3)
    },

    

  }
};